import { inject } from '@angular/core';
import { Router, type ResolveFn } from '@angular/router';
import { Invite } from '@features/organizations/models/invite.model';
import { OrganizationsService } from '@features/organizations/services/organizations.service';
import { catchError, EMPTY, mergeMap, Observable, of } from 'rxjs';

export const codeResolver: ResolveFn<Invite | null> = (route, state): Observable<Invite | null> => {
  const router = inject(Router);
  const orgService = inject(OrganizationsService);

  const code = route.paramMap.get('code');

  if (!code) {
    return of(null);
  }

  return orgService.getInviteByCode(code).pipe(catchError(() => of(null)));
};
